import React from 'react'
import styled from 'styled-components'
import { FaPinterest, FaFacebookSquare, FaInstagram } from 'react-icons/fa'
import { BsHouseDoorFill } from 'react-icons/bs'
import { FaStar } from 'react-icons/fa'
import { useAppContext } from 'context/AppContext'
import { PUBLIC_LINK_BASE, LINK_BASE } from 'variables/general'
import { profilePageIcons } from 'components/admin/Images'
const { headerCoverPhoto } = profilePageIcons

const PublicHeader = (props) => {
  const [context] = useAppContext()

  let newTabURL =
    props.location === 'marketplace-package'
      ? `${LINK_BASE}/marketplace-portfolio/${props.photographer.identifier}/`
      : `${PUBLIC_LINK_BASE(props.photographer)}/portfolio/${props.photographer.identifier}/`

  // HEY
  return (
    <Container>
      <ImgWrap>
        <Img src={props.coverPhoto || headerCoverPhoto} alt="public header cover image" />
      </ImgWrap>
      {!context.isMobile ? (
        <SubContainer1 $booking={props.booking}>
          <AvatarWrap href={newTabURL} rel="noopener" target="_blank">
            <AvatarImg
              src={props.photographer.displayImage || headerCoverPhoto}
              alt="public header avatar image"
            />
          </AvatarWrap>
          <Col1>
            <H1 href={newTabURL} rel="noopener" target="_blank">
              {props.photographer.companyName}
            </H1>
            <Row1 font={props.secondaryFont ? props.secondaryFont : props.font}>
              <H2 href={newTabURL} rel="noopener" target="_blank">
                {props.photographer.location ? props.photographer.location.name : 'Victoria, BC'}
              </H2>
              {props.photographer.review && (
                <SubRow href={props.photographer?.review?.url} rel="noopener" target="_blank">
                  <H3> | {props.photographer?.review?.rating}/5.0 </H3>
                  <StarIcon />
                  <H3> {props.photographer?.review?.number} Reviews</H3>
                </SubRow>
              )}
            </Row1>
          </Col1>
          <Col2>
            {props.photographer.socials.length > 0 && (
              <SocialIcons>
                {props.photographer.socials.map((social) => (
                  <A href={`${social.url}`} key={social.socialSite.name}>
                    {social.socialSite.name === 'Website' && <WebSite />}
                    {social.socialSite.name === 'Instagram' && <Instagram />}
                    {social.socialSite.name === 'Facebook' && <Facebook />}
                    {social.socialSite.name === 'Pinterest' && <Pinterest />}
                  </A>
                ))}
              </SocialIcons>
            )}
          </Col2>
        </SubContainer1>
      ) : (
        <SubContainer2>
          <SocialIconsWrapper>
            {props.photographer.socials.length > 0 && (
              <SocialIcons>
                {props.photographer.socials.map((social) => (
                  <A href={`${social.url}`} key={social.socialSite.name}>
                    {social.socialSite.name === 'Website' && <WebSite />}
                    {social.socialSite.name === 'Instagram' && <Instagram />}
                    {social.socialSite.name === 'Facebook' && <Facebook />}
                    {social.socialSite.name === 'Pinterest' && <Pinterest />}
                  </A>
                ))}
              </SocialIcons>
            )}
          </SocialIconsWrapper>
          <H1 href={newTabURL} rel="noopener" target="_blank">
            {props.photographer.companyName}
          </H1>
          <Row1 font={props.secondaryFont ? props.secondaryFont : props.font}>
            <H2 href={newTabURL} rel="noopener" target="_blank">
              {props.photographer.location ? props.photographer.location.name : 'Victoria, BC'}
            </H2>
            {props.photographer.review && (
              <SubRow href={props.photographer?.review?.url} rel="noopener" target="_blank">
                <H3> | {props.photographer?.review?.rating}/5.0 </H3>
                <StarIcon />
                <H3> {props.photographer?.review?.number} Reviews</H3>
              </SubRow>
            )}
          </Row1>
        </SubContainer2>
      )}
    </Container>
  )
}

export default PublicHeader

const Container = styled.div`
  position: relative;
  width: 100%;
  background: black;
  height: 260px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  color: white;
  @media (max-width: 900px) {
    height: 250px;
  }
  @media (max-width: 400px) {
    font-size: 9px;
  }
  @media (max-width: 360px) {
    font-size: 8px;
  }
`

const SubContainer1 = styled.div`
  position: relative;
  padding: ${(props) => (props.$booking ? '30px 60px' : '30px 60px 30px 0')};
  height: 100%;
  width: 90vw;
  display: flex;
  justify-content: space-between;
`
const SubContainer2 = styled.div`
  position: relative;
  padding: 30px 60px;
  height: 100%;
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  @media (max-width: 900px) {
    padding: 12px;
    justify-content: flex-end;
  }
  @media (max-width: 360px) {
    font-size: 7px;
  }
`
const ImgWrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const Img = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.7;
`
const AvatarWrap = styled.a`
  position: absolute;
  bottom: 0;
  right: 44%;
  // right: 60px;
  transform: translate(0%, 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  border-radius: 999px;
  border: 5px solid #fff;
  background: white;
`

const AvatarImg = styled.img`
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 999px;
  object-fit: cover;
  cursor: pointer;
`

const SocialIcons = styled.div`
  position: relative;
  display: inline-block;
  font-size: 2.8em;
  z-index: 2;
`
const SocialIconsWrapper = styled.div`
  position: absolute;
  right: 0px;
  top: 12px;
`

const Facebook = styled(FaFacebookSquare)`
  margin: 0 15px 0 0;
`

const Instagram = styled(FaInstagram)`
  margin: 0 15px 0 0;
`

const WebSite = styled(BsHouseDoorFill)`
  margin: 0 15px 0 0;
`

const Pinterest = styled(FaPinterest)`
  margin: 0 15px 0 0;
`

const Col1 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: flex-end;
  height: 100%;
  width: auto;
`

const Col2 = styled.div`
  position: relative;
  width: auto;
  height: 100%;
`
const A = styled.a`
  position: relative;
  display: inline-block;
  &:hover {
    opacity: 1;
  }
`
const H1 = styled.a`
  position: relative;
  margin: 0 0 12px 0;
  padding: 0;
  font-weight: 600;
  font-size: 3.2em;
  text-align: left;
  cursor: pointer;
  @media (max-width: 1250px) and (min-width: 1150.02px) {
    font-size: 3em;
  }
  @media (max-width: 1150px) and (min-width: 900.02px) {
    font-size: 2.8em;
  }
  @media (max-width: 900px) {
    margin: 0;
    font-size: 2.8em;
  }
`

const H2 = styled(H1)`
  font-size: 1.6em;
  @media (max-width: 1250px) {
    font-size: 1.6em;
  }
  font-weight: 600;
  margin: 0;
`
const H3 = styled.div`
  position: relative;
  margin: 0 6px;
  padding: 0;
  font-weight: 600;
  font-size: 1.6em;
`

const Row1 = styled.div`
  position: relative;
  display: flex;
  font-family: ${(props) => !!props.font && props.font};
`

const StarIcon = styled(FaStar)`
  font-size: 1.7em;
  padding: 0;
`

const SubRow = styled.a`
  position: relative;
  display: flex;
  cursor: pointer;
`
